export default __webpack_public_path__ + "static/ico-dzialanie-6d50c4a8819e1842eff7ccf2767f6abf.svg";